<template>
  <div class="service-card">
    <!-- 收费公告 -->
    <div class="service-notice" v-if="noticeVisible">
      <div class="service-header">
        <i class="yk-tips"></i>
        <div class="service-header__name">黄页为收费栏目</div>
      </div>
      <div class="notice-content">
        <p>信息发布后，处于待审核状态。只有自助定制广告并支付费用，或联系我们投放广告，信息才会公开显示。</p>
        <p>如长时间未定制广告，相关信息将被除。任何疑问，欢迎联系约克论坛广告部。</p>
      </div>
    </div>
    <!-- 常见问题 -->
    <div class="service-question">
      <div class="service-header">
        <i class="yk-publish_question"></i>
        <div class="service-header__name">常见问题</div>
      </div>
      <div class="question-list">
        <a
          class="question-item"
          v-for="(item, i) in questionList"
          :key="i"
          target="_blank"
          :href="`${item.path}` | hostBuild(item.host)"
          >{{ item.title }}</a
        >
      </div>
    </div>
    <!-- 联系我们 -->
    <div class="service-concat">
      <div class="service-header">
        <i class="yk-kefu"></i>
        <div class="service-header__name">联系我们</div>
      </div>
      <div class="concat-content">
        <div class="concat-subtitle">约克论坛客服为您在线答疑</div>
        <YorkbbsImage class="concat-qrcode" :src="require('@/assets/images/common/qrcode-service.png')"></YorkbbsImage>
        <div class="concat-tip">扫一扫加客服微信</div>
        <div class="concat-list">
          <div class="concat-item">电话：416-628-9108</div>
          <div class="concat-item">邮箱：admin@yorkbbs.ca</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'CardServer',
  props: {
    // 是否显示收费公告
    noticeVisible: Boolean,
    // 问题列表
    questionList: Array,
  },
};
</script>
<style lang="scss" scoped>
.service-card {
  background: #ffffff;
  border-radius: 10px;
  padding: 20px;
}
.service-header {
  display: flex;
  i {
    line-height: 25px;
    font-size: 20px;
    color: var(--primary-color);
    margin-right: 10px;
  }
}
.service-header__name {
  font-size: 18px;
  line-height: 25px;
  font-weight: 600;
}

.service-notice {
  margin-bottom: 35px;
}
.notice-content {
  font-size: 14px;
  line-height: 24px;
  color: var(--text-color-6);
  margin-top: 15px;
  p + p {
    margin-top: 15px;
  }
}
.service-question {
  margin-bottom: 35px;
}
.question-list {
  margin-top: 25px;
}
.question-item {
  display: block;
  font-size: 16px;
  line-height: 22px;
  &::before {
    content: '•';
    color: #ccc;
    margin-right: 10px;
  }
  &:hover {
    color: var(--primary-color);
  }
}
.question-item + .question-item {
  margin-top: 18px;
}

.concat-content {
  padding-left: 30px;
}
.concat-subtitle {
  font-size: 14px;
  line-height: 20px;
  color: var(--text-color-9);
  margin-top: 4px;
  margin-bottom: 20px;
}
.concat-qrcode {
  width: 160px;
  height: 160px;
  margin-bottom: 12px;
}
.concat-tip {
  font-size: 14px;
  line-height: 20px;
  margin-bottom: 15px;
}
.concat-item {
  font-size: 14px;
  line-height: 24px;
  color: var(--text-color-3);
}
</style>
